import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=8e4baff0&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./style.css?vue&type=style&index=0&id=8e4baff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4baff0",
  null
  
)

export default component.exports